/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon16Light = forwardRef('SendPaperplaneDiagIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.214 7.129c-.859-.592-.659-1.913.337-2.223L12.729 1.42a1.25 1.25 0 0 1 1.566 1.565L10.81 14.165c-.31.995-1.632 1.195-2.223.336L5.58 10.135 1.214 7.129Zm5.374 2.706 2.823 4.1a.25.25 0 0 0 .444-.068L13.34 2.689a.25.25 0 0 0-.313-.314L1.849 5.86a.25.25 0 0 0-.068.445l4.1 2.823 2.67-2.671a.5.5 0 0 1 .708.707l-2.671 2.67Z" })));
});
